__webpack_require__.p = "https://qr-code-generator.digital.vpsvc.com/";